/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import PropTypes from 'prop-types';
import { ExclamationTriangleIcon } from '@heroicons/react/20/solid';
import i18n from '../../../i18n';
import ToolTipNoIcon from '../../../elements/ToolTipNoIcon';

// TableBody passes a 'value' prop to the displayElement component
// pass the id of the message from locale to be shown
export function WarningWithTooltip({ value }) {
  return (
    <ToolTipNoIcon info={i18n.t(`accountDetails:${value}`)} classNameOwn="w-5 -mb-0.5">
      <ExclamationTriangleIcon className="w-5 h-5 text-brandYellow-500 cursor-pointer" />
    </ToolTipNoIcon>
  );
}

WarningWithTooltip.propTypes = {
  value: PropTypes.string,
};

WarningWithTooltip.defaultProps = {
  value: '',
};

export function SplitIcon({ value }) {
  if (typeof value !== 'number') {
    return (
      <div id="split-icon" className="inline-block rounded-full bg-gray-300 ml-0.5 align-text-bottom font-bold text-center px-1 text-xs text-white w-4">
        S
      </div>
    );
  }

  return (
    <div className="ml-1 inline-flex items-center gap-1">
      <span>{`(${value} `}</span>
      <span id="split-icon" className="inline-block rounded-full bg-gray-300 ml-0.5 font-bold text-center px-1 text-xs text-white w-4 h-4">
        S
      </span>
      <span>)</span>
    </div>
  );
}

export function OriginalCurrencyComponent({ value }) {
  return <span>{` | ${value}`}</span>;
}

OriginalCurrencyComponent.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

OriginalCurrencyComponent.defaultProps = {
  value: '',
};
